
import {sendRecordResult, followDisableOption, timeRangeOptions } from "@/utils/options";
const dateTypeOptions = [
    {id: 'requestDate', text: '请求时间'},
    {id: 'purchaseDate', text: '订购时间'},
    {id: 'shippingDate', text: '发货时间'},
]
export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '全部状态',
    prop: 'status',
    components: [{
        name: 'gj-select',
        prop: 'status',
        propsData: {
            placeholder: '全部状态',
            options: followDisableOption
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '监控人',
    prop: 'createUserId',
    components: [{
        name: 'gj-creator-select',
        prop: 'createUserId',
        propsData: {
            placeholder: '监控人'
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}]
